var a, s,
SC = {
  
  elements: {
    siteLoader: document.querySelector('[site-loader]'),
    topLevelMenuItems: document.querySelectorAll('[top-level-menu-item]'),
    secondLevelMenuItems: document.querySelectorAll('[second-level-menu-item]'),
    searchTriggers: document.querySelectorAll('[header-search-trigger]'),
    searchInput: document.querySelector('[header-search-form-input]'),
    mobMenuTrigger: document.querySelector('[header-mob-menu-trigger]'),
    topLevelMobMenuItems: document.querySelectorAll('[top-level-mob-menu-item]'),
    topLevelMobMenuBackBtns: document.querySelectorAll('[top-level-mob-menu-item-back-btn]'),
    secondLevelMobMenuItems: document.querySelectorAll('[second-level-mob-menu-item]'),
    cartTriggers: document.querySelectorAll('[header-cart-trigger]'),
    cartDrawer: document.querySelector('[cart-drawer]'),
    cartDrawerCloseBtn: document.querySelector('[cart-drawer-close-btn]'),
    accountTriggers: document.querySelectorAll('[header-account-trigger]'),
    accountDrawer: document.querySelector('[account-drawer]'),
    accountDrawerCloseBtn: document.querySelector('[account-drawer-close-btn]'),
    backdrop: document.querySelector('[backdrop]'),
    helpPopup: document.querySelector('[help-popup]'),
    helpPopupWrap: document.querySelector('[help-popup-wrap]'),
    helpPopupCloseBtn: document.querySelector('[help-popup-close-btn]'),
    helpTriggers: document.querySelectorAll('[help-trigger]'),
    accountForgotPassTrigger: document.querySelector('[account-forgot-password-trigger]'),
    announcementBar: document.querySelector('[announcement-bar]'),
    newsletterPopup: document.querySelector('.newsletter-popup'),
    newsletterPopupCloseBtn: document.querySelector('[newsletter-popup-close-btn]'),
  },

  settings: {
    debounceTimer: null
  },

  init: function() {
    a = this.elements;
    s = this.settings;
    this.onevh();
    this.siteLoader();
    this.menu();
    this.mobMenu();
    this.search();
    this.cartDrawer();
    this.accountDrawer();
    this.helpPopup();
    this.backdrop();
    this.announcementBar();
    this.header();
    this.redirects();
    this.newsletterPopup();
    this.cart();
    this.footer();

    this.heroBanner();
    this.gallery();
    this.blogListingPagination();
    this.articleSliders();
    this.productSingleSlider();
    this.productSingleVariants();
    this.productSingleAccordions();
    this.productSingleRecommendations();
    this.collectionFiltering();
    this.collectionFilteringMobile();
    this.collectionInfiniteLoading();
    this.redirects();
    this.account();
    this.paintProgram();
    this.articles();
    this.policies();
    new CustomerAddresses();
    this.productEtaForm();
    this.contentVisibiity();
  },

  swup: () => {
    a.swup = new Swup({
      plugins: [
        new SwupFormsPlugin(),
        new SwupScrollPlugin({
          doScrollingRightAway: false,
          animateScroll: false,
        }),
        new SwupBodyClassPlugin(),
        new SwupScriptsPlugin({
          head: false,
          body: true,
        })
      ],
      animateHistoryBrowsing: true,
      containers: [
        '.site-content',
      ],
    });

    a.swup.on('contentReplaced', () => {
      SC.heroBanner();
      SC.gallery();
      SC.blogListingPagination();
      SC.articleSliders();
      SC.productSingleSlider();
      SC.productSingleVariants();
      SC.productSingleAccordions();
      SC.productSingleRecommendations();
      SC.collectionFiltering();
      SC.collectionFilteringMobile();
      SC.collectionInfiniteLoading();
      SC.redirects();
      SC.account();
      SC.paintProgram();
      SC.articles();
      SC.policies();
      new CustomerAddresses();
      SC.productEtaForm();
      SC.contentVisibiity();

      WRKSP.init();
      
      // Appointly
      setTimeout(async () => {
        const pidEl = document.querySelector("[name='product-id']");
        

        if (!pidEl) return;

        const productId = pidEl.value;        

        const client = window.appointlyClient || await appointlyClient.init(window.appointlyConfig);

        const prods = await window.appointlyClient.getActiveServiceProductIds();

        if (!prods.includes(productId)) return;   

        // load the new service (async!)
        await client.getService(productId);


        // 1) If their button already exists, just retarget it
        const btn = document.getElementById("apntly-book-button");
        if (btn) {
          btn.setAttribute("data-atc-btn-product-id", String(productId));
          // make sure click opens the right product
          btn.onclick = (e) => client.openBookModal(e);
          return;
        }

        // 2) Otherwise, (re)insert the button next to the ATC button
        await client.addButton(0, productId);
      }, 300)
    });
  },

  policies: () => {
    const policyBody = document.querySelector('.shopify-policy__body');

    if (policyBody) {
      policyBody.classList.add('content');
    }
  },

  articles: () => {

    const articleImages = document.querySelectorAll('.article-single__content img');

    if (articleImages) {
      for (let articleImage of articleImages) {
        articleImage.classList.add('article-single__content-img');
        if (articleImage.complete) {
          // The image is already loaded, call handler
          checkImage(articleImage);
        } else {
          // The image is not loaded yet, set load event handler
          articleImage.addEventListener("load", function() {
            checkImage(this);
          })
        }

        function checkImage(img) {
          if (img.naturalHeight > img.naturalWidth) {
            articleImage.classList.add('article-single__content-img--portrait');
          } else {
            articleImage.classList.add('article-single__content-img--landscape');
          }
        }
      }
    }
  },

  redirects: () => {
    if (window.location.pathname == '/cart') {
		window.location.href = '/?cart=true'; 
	}

    if (window.location.pathname == '/account/login' || window.location.pathname == '/account/register' || window.location.pathname == '/account/recover') {
      window.location.href = '/?account=true';
    }

    if (window.location.pathname.includes('/account/orders/')) {
      window.location.href = '/account';
    }
  },

  productSingleRecommendations: () => {
    const productRecommendationsSection = document.querySelector('.product-recommendations');

    if (productRecommendationsSection) {
      const url = productRecommendationsSection.dataset.url;
    
      fetch(url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('.product-recommendations');
      
          if (recommendations && recommendations.innerHTML.trim().length) {
            productRecommendationsSection.innerHTML = recommendations.innerHTML;
          }
        })
        .catch(e => {
          console.error(e);
        });
    }
  },

  siteLoader: () => {
    setTimeout(() => {
      a.siteLoader.classList.add('site-loader--done');
    }, 250);
  },

  header: () => {
    const header = document.querySelector(".header");

    const headroom = new Headroom(header, {
      onUnpin: SC.headroomUnpin,
    });
    headroom.init();


    const siteContent = document.querySelector('.site-content');

    if (!siteContent) {
      return;
    }

    const headerPadding = () => {
      siteContent.style.paddingTop = header.offsetHeight + 'px';
    }

    headerPadding();

    window.addEventListener('resize', () => {
      headerPadding();
    });
  },

  headroomUnpin: () => {
    SC.closeTopLevelMenuItems();
    
    if (document.activeElement !== a.searchInput) {
      SC.closeSearch();
    }
  },
  
  onevh: () => {
    const set1vh = () => {
      const vh = document.documentElement.clientHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);


      const annoucementBar = document.querySelector('[header-announcement-bar]');
      if (annoucementBar) {
        document.documentElement.style.setProperty('--announcement-bar', `${annoucementBar.offsetHeight}px`);
      }
    };

    set1vh();

    window.addEventListener('resize', set1vh);
  },
  
  menu: () => {
    for (const menuItem of a.topLevelMenuItems) {
      menuItem.addEventListener('mouseenter', () => {
        document.body.classList.add('desktop-menu-active');

        menuItem.setAttribute('aria-expanded', true);
        const menuItemTarget = document.querySelector(`#${menuItem.getAttribute('aria-controls')}`);
        menuItemTarget.setAttribute('aria-expanded', true);

        SC.closeSearch();
      });

      menuItem.addEventListener('mouseleave', () => {
        document.body.classList.remove('desktop-menu-active');

        menuItem.setAttribute('aria-expanded', false);
        const menuItemTarget = document.querySelector(`#${menuItem.getAttribute('aria-controls')}`);
        menuItemTarget.setAttribute('aria-expanded', false);
      });
    }

    for (const menuItem of a.secondLevelMenuItems) {
      menuItem.addEventListener('mouseenter', () => {
        if (menuItem.getAttribute('aria-expanded')) {
          menuItem.setAttribute('aria-expanded', true);
          const menuItemTarget = document.querySelector(`#${menuItem.getAttribute('aria-controls')}`);
          menuItemTarget.setAttribute('aria-expanded', true);
          menuItem.closest('[second-level-menu-items]').classList.remove('header__menu-list-sub-col-list--menu-items-active');
        }

        menuItem.closest('[second-level-menu-items]').classList.add('header__menu-list-sub-col-list--menu-items-active');
      });

      menuItem.addEventListener('mouseleave', () => {
        if (menuItem.getAttribute('aria-expanded')) {
          menuItem.setAttribute('aria-expanded', false);
          const menuItemTarget = document.querySelector(`#${menuItem.getAttribute('aria-controls')}`);
          menuItemTarget.setAttribute('aria-expanded', false);
          menuItem.closest('[second-level-menu-items]').classList.remove('header__menu-list-sub-col-list--menu-items-active');
        }

        menuItem.closest('[second-level-menu-items]').classList.remove('header__menu-list-sub-col-list--menu-items-active');
      });
    }

    const allMenuLinks = document.querySelectorAll('.header a');
    for (let allMenuLink of allMenuLinks) {
      allMenuLink.addEventListener('click', () => {
        SC.closeTopLevelMenuItems();
      });
    }
  },

  closeTopLevelMenuItems: () => {
    for (const menuItem of a.topLevelMenuItems) {
      document.body.classList.remove('desktop-menu-active');
      menuItem.setAttribute('aria-expanded', false);
      const menuItemTarget = document.querySelector(`#${menuItem.getAttribute('aria-controls')}`);
      menuItemTarget.setAttribute('aria-expanded', false);
    }
  },

  mobMenu: () => {
    a.mobMenuTrigger.addEventListener('click', () => {
      const expanded = a.mobMenuTrigger.getAttribute('aria-expanded') === 'true';

      a.mobMenuTrigger.setAttribute('aria-expanded', !expanded);
      const mobMenuTarget = document.querySelector(`#${a.mobMenuTrigger.getAttribute('aria-controls')}`);
      mobMenuTarget.setAttribute('aria-expanded', !expanded);
      a.announcementBar.parentNode.classList.remove('announcement-bar--active');
      a.announcementBar.parentNode.setAttribute('inert', '');

      if (!expanded) {
        document.body.classList.add('mob-menu-active');
        document.body.classList.add('overflow-hidden');
      } else {
        document.body.classList.remove('mob-menu-active');
        document.body.classList.remove('overflow-hidden');
      }

      SC.closeSearch();
    });

    const headerLinks = document.querySelectorAll('.header__mob-menu a');

    if (headerLinks) {
      for (let headerLink of headerLinks) {
        headerLink.addEventListener('click', () => {
          SC.closeMobileMenu();
        });
      }
    }

    for (const topLevelMobMenuItem of a.topLevelMobMenuItems) {
      topLevelMobMenuItem.addEventListener('click', () => {
        const expanded = topLevelMobMenuItem.getAttribute('aria-expanded') === 'true';
        const menuItemTarget = document.querySelector(`#${topLevelMobMenuItem.getAttribute('aria-controls')}`);
        topLevelMobMenuItem.setAttribute('aria-expanded', !expanded);
        menuItemTarget.setAttribute('aria-expanded', !expanded);
      });
    }

    for (let topLevelMobMenuBackBtn of a.topLevelMobMenuBackBtns) {
      topLevelMobMenuBackBtn.addEventListener('click', () => {
        const menuItem = document.querySelector(`[aria-controls=${topLevelMobMenuBackBtn.getAttribute('aria-controls')}]`);
        const menuItemTarget = document.querySelector(`#${topLevelMobMenuBackBtn.getAttribute('aria-controls')}`);
        menuItem.setAttribute('aria-expanded', false);
        menuItemTarget.setAttribute('aria-expanded', false);
      });
    }

    for (let secondLevelMobMenuItem of a.secondLevelMobMenuItems) {
      secondLevelMobMenuItem.addEventListener('click', () => {
        const expanded = secondLevelMobMenuItem.getAttribute('aria-expanded') === 'true';
        const menuItemTarget = document.querySelector(`#${secondLevelMobMenuItem.getAttribute('aria-controls')}`);
        secondLevelMobMenuItem.setAttribute('aria-expanded', !expanded);
        menuItemTarget.setAttribute('aria-expanded', !expanded);
      });
    }
  },

  closeMobileMenu: () => {
    a.mobMenuTrigger.setAttribute('aria-expanded', false);
    const mobMenuTarget = document.querySelector(`#${a.mobMenuTrigger.getAttribute('aria-controls')}`);
    mobMenuTarget.setAttribute('aria-expanded', false);
    document.body.classList.remove('mob-menu-active');
    document.body.classList.remove('overflow-hidden');
  },

  debounce: (callback, time) => {
    window.clearTimeout(a.debounceTimer);
    a.debounceTimer = window.setTimeout(callback, time);
  },

  search: () => {
    for (const searchTrigger of a.searchTriggers) {
      searchTrigger.addEventListener('click', () => {
        const expanded = searchTrigger.getAttribute('aria-expanded') === 'true';

        for (const searchTriggerr of a.searchTriggers) {
          searchTriggerr.setAttribute('aria-expanded', !expanded);
        }
        
        const searchTarget = document.querySelector(`#${searchTrigger.getAttribute('aria-controls')}`);
        searchTarget.setAttribute('aria-expanded', !expanded);
  
        if (!expanded) {
          // https://stackoverflow.com/questions/12204571/mobile-safari-javascript-focus-method-on-inputfield-only-works-with-click
          // create invisible dummy input to receive the focus first
          const fakeInput = document.createElement('input')
          fakeInput.setAttribute('type', 'text')
          fakeInput.style.position = 'absolute'
          fakeInput.style.opacity = 0
          fakeInput.style.height = 0
          fakeInput.style.fontSize = '16px' // disable auto zoom
        
          // you may need to append to another element depending on the browser's auto 
          // zoom/scroll behavior
          document.body.prepend(fakeInput)
        
          // focus so that subsequent async focus will work
          fakeInput.focus()
        
          setTimeout(() => {
            // now we can focus on the target input
            a.searchInput.focus()
            // cleanup
            fakeInput.remove()
          }, 350);
          
          document.body.classList.remove('desktop-menu-active');
          document.body.classList.remove('mob-menu-active');
        }

        SC.closeMobileMenu();
      }); 
    }

    a.searchInput.closest('form').addEventListener('submit', e => {
      SC.closeSearch();
    });
  },

  closeSearch: () => {
    for (const searchTrigger of a.searchTriggers) {
      const searchTarget = document.querySelector(`#${searchTrigger.getAttribute('aria-controls')}`);
      searchTarget.setAttribute('aria-expanded', false);
      searchTrigger.setAttribute('aria-expanded', false);
    }
  },

  cartDrawer: () => {
    for (const cartTrigger of a.cartTriggers) {
      cartTrigger.addEventListener('click', () => {
        SC.openCart(cartTrigger);
      });
    }

    a.cartDrawerCloseBtn.addEventListener('click', () => {
      SC.closeCart();
    });

    // Open cart if ?cart=true
	const url_search_params = new URLSearchParams(window.location.search);
	const params = Object.fromEntries(url_search_params.entries());
	if (params.cart) {
      SC.openCart();
	}
  },

  openCart: (cartTrigger) => {
    a.cartDrawer.setAttribute('aria-expanded', true);
    if (cartTrigger) {
      cartTrigger.setAttribute('aria-expanded', true);
    }
    SC.openBackdrop();
  },

  closeCart: () => {
    for (const cartTrigger of a.cartTriggers) {
      cartTrigger.setAttribute('aria-expanded', false);
    }

    a.cartDrawer.setAttribute('aria-expanded', false);

    SC.closeBackdrop();
  },

  accountDrawer: () => {
    for (const accountTrigger of a.accountTriggers) {
      accountTrigger.addEventListener('click', () => {
        SC.openAccount(accountTrigger);
      });
    }

    // Open cart if ?account=true
    const url_search_params = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(url_search_params.entries());
    if (params.account) {
        SC.openAccount();
    }

    a.accountDrawerCloseBtn.addEventListener('click', () => {
      SC.closeAccount();
    });

    a.accountForgotPassTrigger.addEventListener('click', () => {
      gsap.to(document.querySelector('.account-drawer__recover'), { duration: 0.25, height: 'auto', autoAlpha: 1 });
    });

    const loginForm = a.accountDrawer.querySelector('.account-drawer__login');

    if (loginForm) {
      loginForm.addEventListener('submit', e => {
        e.preventDefault();
        a.accountDrawer.classList.add('drawer-loader--loading');

        const button = document.querySelector('.account-drawer__login-button');
        button.disabled = true;

        fetch(e.target.action, {
          method: 'POST',
          body: new FormData(e.target),
    	}).then(response => {
          if (response.ok) {
            return response.text();
          }
    	}).then(data => {
          const parser = new DOMParser();
          data = parser.parseFromString(data, 'text/html');
  
          const errorCheck = data.querySelector('.account-drawer__login-error');

          const existingError = document.querySelector('.account-drawer__login-error');

          if (existingError) {
            existingError.remove();
          }

          if (errorCheck) {
            e.target.insertAdjacentHTML('afterbegin', errorCheck.outerHTML);
            button.disabled = false;
          } else {
            const successHTML = `<p class="account-drawer__login-success" tabindex="-1" autofocus><u>Login success</u></p>`;
            e.target.insertAdjacentHTML('afterbegin', successHTML);

            setTimeout(function() {              
              window.location = window.location.href;
            }, 3000);
          }

          a.accountDrawer.classList.remove('drawer-loader--loading');
    	}).catch(error => {
          console.warn(error);
    	});
      });
    }

    const recoverForm = a.accountDrawer.querySelector('.account-drawer__recover');

    if (recoverForm) {
      recoverForm.addEventListener('submit', e => {
        e.preventDefault();
        a.accountDrawer.classList.add('drawer-loader--loading');

        fetch(e.target.action, {
          method: 'POST',
          body: new FormData(e.target),
    	}).then(response => {
          if (response.ok) {
            return response.text();
          }
    	}).then(data => {
          const parser = new DOMParser();
          data = parser.parseFromString(data, 'text/html');

          const errorCheck = data.querySelector('.account-drawer__recover-error');
          const successCheck = data.querySelector('.account-drawer__recover-success');

          const title = document.querySelector('.account-drawer__recover-title');
          const existingError = document.querySelector('.account-drawer__recover-error');
          if (existingError) {
            existingError.remove();
          }

          if (errorCheck) {
            title.insertAdjacentHTML('afterend', errorCheck.outerHTML);
          } else if (successCheck) {
            title.insertAdjacentHTML('afterend', successCheck.outerHTML);
          }

          a.accountDrawer.classList.remove('drawer-loader--loading');
    	}).catch(error => {
          console.warn(error);
    	});
      });
    }

    const createForm = a.accountDrawer.querySelector('.account-drawer__create');

    if (createForm) {
      createForm.addEventListener('submit', e => {
        e.preventDefault();
        a.accountDrawer.classList.add('drawer-loader--loading');

        const button = document.querySelector('.account-drawer__create-button');
        button.disabled = true;

        fetch(e.target.action, {
          method: 'POST',
          body: new FormData(e.target),
    	}).then(response => {
          if (response.ok) {
            return response.text();
          }
    	}).then(data => {
          const parser = new DOMParser();
          data = parser.parseFromString(data, 'text/html');

          const errorCheck = data.querySelector('.account-drawer__create-error');

          const title = document.querySelector('.account-drawer__create-title');
          const existingError = document.querySelector('.account-drawer__create-error');
          if (existingError) {
            existingError.remove();
          }

          if (errorCheck) {
            title.insertAdjacentHTML('afterend', errorCheck.outerHTML);
            button.disabled = false;
          } else {
            const successHTML = `<p class="account-drawer__create-success" tabindex="-1" autofocus><u>Account creation success</u></p>`;
            title.insertAdjacentHTML('afterend', successHTML);

            setTimeout(function() {              
              window.location = window.location.href;
            }, 3000);
          }

          a.accountDrawer.classList.remove('drawer-loader--loading');
    	}).catch(error => {
          console.warn(error);
    	});
      });
    }

    const contactForm = document.querySelector('.contact-form');

    if (contactForm) {
      contactForm.addEventListener('submit', e => {
        e.preventDefault();

        const button = document.querySelector('.contact-form__button');
        button.disabled = true;

        fetch(e.target.action, {
          method: 'POST',
          body: new FormData(e.target),
    	}).then(response => {
          if (response.ok) {
            return response.text();
          }
    	}).then(data => {
          const parser = new DOMParser();
          data = parser.parseFromString(data, 'text/html');

          const errorCheck = data.querySelector('.contact-form__error');
          const successCheck = data.querySelector('.contact-form__success');

          const existingError = document.querySelector('.contact-form__error');
          if (existingError) {
            existingError.remove();
          }

          if (errorCheck) {
            e.target.insertAdjacentHTML('afterbegin', errorCheck.outerHTML);
          } else if (successCheck) {
            e.target.insertAdjacentHTML('afterbegin', successCheck.outerHTML);
            e.target.reset();
          }

          button.disabled = false;
    	}).catch(error => {
          console.warn(error);
    	});
      });
    }
  },

  openAccount: (accountTrigger) => {
    if (accountTrigger) {
      accountTrigger.setAttribute('aria-expanded', true);
    }
    a.accountDrawer.setAttribute('aria-expanded', true);
    SC.openBackdrop();
  },

  closeAccount: () => {
    for (const accountTrigger of a.accountTriggers) {
      accountTrigger.setAttribute('aria-expanded', false);
    }

    a.accountDrawer.setAttribute('aria-expanded', false);

    SC.closeBackdrop();
  },

  helpPopup: () => {
    for (const helpTrigger of a.helpTriggers) {
      helpTrigger.addEventListener('click', () => {
        SC.openHelp(helpTrigger);
      });
    }

    a.helpPopupCloseBtn.addEventListener('click', () => {
      SC.closeHelp();
    });

    a.helpPopup.addEventListener('click', () => {
      SC.closeHelp();
    });

    a.helpPopupWrap.addEventListener('click', e => {
      e.stopPropagation();
    });

    const helpForm = document.querySelector('.help-popup__form');

    if (helpForm) {
      helpForm.addEventListener('submit', e => {
        e.preventDefault();

        const button = document.querySelector('.help-popup__form-button');
        button.disabled = true;

        fetch(e.target.action, {
          method: 'POST',
          body: new FormData(e.target),
    	}).then(response => {
          if (response.ok) {
            return response.text();
          }
    	}).then(data => {
          const parser = new DOMParser();
          data = parser.parseFromString(data, 'text/html');

          const errorCheck = data.querySelector('.help-popup__form-error');
          const successCheck = data.querySelector('.help-popup__form-success');

          const existingError = document.querySelector('.help-popup__form-error');
          if (existingError) {
            existingError.remove();
          }

          if (errorCheck) {
            e.target.insertAdjacentHTML('afterbegin', errorCheck.outerHTML);
          } else if (successCheck) {
            e.target.insertAdjacentHTML('afterbegin', successCheck.outerHTML);
            e.target.reset();
          }

          button.disabled = false;
    	}).catch(error => {
          console.warn(error);
    	});
      });
    }
  },

  openHelp: (helpTrigger) => {
    helpTrigger.setAttribute('aria-expanded', true);
    a.helpPopup.setAttribute('aria-expanded', true);
    SC.openBackdrop();
  },

  closeHelp: () => {
    for (const helpTrigger of a.helpTriggers) {
      helpTrigger.setAttribute('aria-expanded', false);
    }

    a.helpPopup.setAttribute('aria-expanded', false);

    SC.closeBackdrop();
  },

  backdrop: () => {
    a.backdrop.addEventListener('click', () => {
      SC.closeBackdrop();
      SC.closeCart();
      SC.closeAccount();
    });
  },

  openBackdrop: () => {
    a.backdrop.classList.add('backdrop--open');
    document.body.classList.add('overflow-hidden');
  },

  closeBackdrop: () => {
    a.backdrop.classList.remove('backdrop--open');
    document.body.classList.remove('overflow-hidden');
  },

  announcementBar: () => {
    if (a.announcementBar) {
      a.announcementBar.addEventListener('click', () => {
        a.announcementBar.parentNode.classList.remove('announcement-bar--active');
        a.announcementBar.parentNode.setAttribute('inert', '');
      });

      document.addEventListener("scroll", e => {
        if (window.scrollY < 120) {
          return;
        }
        a.announcementBar.parentNode.classList.remove('announcement-bar--active');
        a.announcementBar.parentNode.setAttribute('inert', '');
      });
    }
  },

  heroBanner: () => {
    const heroBannerSliders = document.querySelectorAll('[hero-banner-slider-images]');

    if (heroBannerSliders.length > 0) {
      for (let heroBannerSlider of heroBannerSliders) {
        const titles = heroBannerSlider.nextElementSibling;
        const flkty1 = new Flickity(heroBannerSlider, {
          prevNextButtons: false,
          pageDots: true,
          autoPlay: parseInt(heroBannerSlider.dataset.autoplay),
          pauseAutoPlayOnHover: false,
          on: {
            ready: function () {
              this.element.classList.remove("hero-banner__slider-images--flex");
              this.resize();
            },
          },
        });

        const flkty2 = new Flickity(titles, {
          prevNextButtons: false,
          pageDots: false,
          draggable: false,
        });

        flkty1.on('change', i => {
          flkty2.select(i);
        });
      } 
    }
  },

  gallery: () => {
    const gallerySectionSlidersDesk = document.querySelectorAll('.gallery-section__slider--desk');
    
    if (gallerySectionSlidersDesk.length) {
      gallerySectionSlidersDesk.forEach((gallerySectionSlider, q) => {
        const gallerySectionSliderMob = gallerySectionSlider.nextElementSibling;

        if (gallerySectionSlider.classList.contains('gallery-section__slider--gram')) {
          const url = 'https://graph.instagram.com/me/media/?fields=media_url,permalink,media_type,thumbnail_url&access_token=' + instagramToken + '';

          fetch(url)
            .then(response => response.json())
            .then(data => {
              if (data) {
                const gallerySectionSliderWrap = gallerySectionSlider.querySelector('.gallery-section__slider-wrap');

                let HTML = '';

                if (!data.data) {
                  return;
                }
                
                data.data.forEach((gram, i) => {
                  if (i < 6) {
                    if (gram.media_type == 'VIDEO') {
                      HTML += `<li class="gallery-section__slider-item${instagramHandle && ` gallery-section__slider-item--handle`}">
                        <figure class="image-container" style="--image-aspect-ratio: 100%">
                          <img
                            data-src="${gram.thumbnail_url}"
                            class="lazyload image-rounded"
                          />
                        </figure>
                        ${instagramHandle && `<a href="https://instagram.com/${instagramHandle}" target="_blank" class="type-h1 gallery-section__slider-item-handle"><span class="gallery-section__slider-item-handle-at">@</span>${instagramHandle}</a>`}
                      </li>`;
                    } else {
                      HTML += `<li class="gallery-section__slider-item${instagramHandle && ` gallery-section__slider-item--handle`}">
                        <figure class="image-container" style="--image-aspect-ratio: 100%">
                          <img
                            data-src="${gram.media_url}"
                            class="lazyload image-rounded"
                          />
                        </figure>
                        ${instagramHandle && `<a href="https://instagram.com/${instagramHandle}" target="_blank" class="type-h1 gallery-section__slider-item-handle"><span class="gallery-section__slider-item-handle-at">@</span>${instagramHandle}</a>`}
                      </li>`;
                    }
                  }
                });

                gallerySectionSliderWrap.innerHTML = HTML;
                gallerySectionSliderMob.innerHTML = HTML;

                SC.gallerySliderDesk(gallerySectionSlider);
                SC.gallerySliderMob(gallerySectionSliderMob);
              }
            });
        } else {
          SC.gallerySliderDesk(gallerySectionSlider);
          SC.gallerySliderMob(gallerySectionSliderMob);
        }
      });
    }
  },

  gallerySliderDesk: (gallerySectionSlider) => {
    const gallerySectionSliderWrap = gallerySectionSlider.querySelector('.gallery-section__slider-wrap');
    gsap.to(gallerySectionSliderWrap, {
      x: () => (gallerySectionSliderWrap.offsetWidth - gallerySectionSlider.offsetWidth) * -1,
      ease: "power1.in",
      scrollTrigger: {
        trigger: gallerySectionSlider,
        start: "top bottom",
        end: "bottom 50%",
        scrub: 1.5
      }
    });
  },

  gallerySliderMob: (gallerySectionSlider) => {
    const flkty = new Flickity(gallerySectionSlider, {
      autoPlay: false,
      pageDots: false,
      prevNextButtons: false,
      cellAlign: 'left',
      contain: true,
      adaptiveHeight: true
    });
  },

  blogListingPagination: () => {
   const paginationNext = document.querySelector('[blog-listing-pagination-link]');

	if (paginationNext) {
      paginationNext.addEventListener('click', e => {
        e.preventDefault();
        SC.loadBlogPosts();
        paginationNext.classList.add('button--loading');
      });
	}
  },

  loadBlogPosts: () => {
	const paginationNext = document.querySelector('[blog-listing-pagination-link]');

	if (paginationNext) {
      const productContainer = document.querySelector('[blog-listing-items]');

      fetch(paginationNext.href)
      .then(response => {
        return response.text()
      }).then(data => {
        const parser = new DOMParser()
        data = parser.parseFromString(data, 'text/html')

        const newProducts = data.querySelector('[blog-listing-items]');
        const newPaginationNext = data.querySelector('[blog-listing-pagination-link]');

        if (newPaginationNext) {
          paginationNext.parentNode.innerHTML = newPaginationNext.parentNode.innerHTML;
        } else {
          paginationNext.parentNode.remove();
        }

        productContainer.insertAdjacentHTML('beforeend', newProducts.innerHTML);
        SC.blogListingPagination();
        paginationNext.classList.remove('button--loading');
      });
	}
  },

  articleSliders: () => {
    const articleMediaSliders = document.querySelectorAll('[article-media-slider]');

    if (articleMediaSliders.length > 0) {
      for (let articleMediaSlider of articleMediaSliders) {
         const flkty = new Flickity(articleMediaSlider, {
          autoPlay: false,
          pageDots: true,
          prevNextButtons: false,
          cellAlign: 'left',
          contain: true,
        });
      }
    }
  },

  productSingleSlider: () => {
    const productSingleMediaSlider = document.querySelector('[product-single-media-slider]');
    const productSingleMediaSliderThumbs = document.querySelector('[product-single-media-slider-thumbs]');

    if (productSingleMediaSlider) {
      const flkty = new Flickity(productSingleMediaSlider, {
        autoPlay: false,
        pageDots: false,
        prevNextButtons: false,
        cellAlign: 'left',
        contain: true,
        adaptiveHeight: true,
        initialIndex: parseInt(productSingleMediaSlider.dataset.start),
      });

      const flkty2 = new Flickity(productSingleMediaSliderThumbs, {
        autoPlay: false,
        prevNextButtons: false,
        contain: true,
        pageDots: false,
        initialIndex: parseInt(productSingleMediaSlider.dataset.start),
        asNavFor: productSingleMediaSlider
      });

      flkty.on('change', function (index) {
        // Pause all videos except the one on the active slide
        flkty.cells.forEach((cell, i) => {
          const video = cell.element.querySelector('video');
          if (video && i !== index) {
            video.pause();
          }
        });
      });
    }
  },

  productSingleVariants: () => {
    const productSubmit = document.querySelector('[product-single-form-submit]');

	if (productSubmit) {
      const productVariantsRawJSON = document.querySelector('[product-single-form-variants]');
      const productVariantsJSON = JSON.parse(productVariantsRawJSON.innerHTML);

      const productPrice = document.querySelector('[product-single-form-price]');
      const productFormId = document.querySelector('[product-single-form-id]');
      const productOptions = document.querySelectorAll('[product-single-form-option]');
      const productQuantity = document.querySelector('[product-single-form-quantity]');
      
      if (productOptions.length) {
        for (const productOption of productOptions) {
          productOption.addEventListener('change', () => {
            SC.productCheckVariants(productFormId, productPrice, productSubmit, productOptions, productVariantsJSON);
          });
        }
      }

      const productForm = productSubmit.closest('form');
      
      productForm.addEventListener('submit', e => {
        e.preventDefault();
        const properties = productForm.querySelectorAll('[name^=properties]');
        SC.productAddToCart(productFormId.value, parseInt(productQuantity.value), productSubmit, properties);
      });
	}
  },

  productCheckVariants: (productFormId, productPrice, productSubmit, productOptions, productVariantsJSON) => {
    let productOptionsArray = [];
    let productSingleVariant = false;

    productOptions.forEach((productOption) => {
        productOptionsArray.push([
          productOption.dataset.index,
          productOption.value,
        ]);
    });

    let i;
    for (i = 0; i < productVariantsJSON.length; i++) {
      const variant = productVariantsJSON[i];
      let matched = [];

      let k;
      for (k = 0; k < productOptionsArray.length; k++) {
        // if value of selected option == the same option number value
        if (productOptionsArray[k][1] == variant[productOptionsArray[k][0]]) {
          matched.push(1);
        } else {
          break;
        }
      }

      if (matched.length == productOptionsArray.length) {
        productSingleVariant = variant;
      }
    }

    if (productSingleVariant) {
      // Update product image slider
      const productSingleMediaSlider = document.querySelector('[product-single-media-slider]');
      if (productSingleMediaSlider && productSingleVariant.featured_image) {
        const flkty = Flickity.data(productSingleMediaSlider);
        flkty.select(productSingleVariant.featured_image.position - 1);
      }
      window.history.replaceState(
        {},
        "",
        `${window.location.pathname}?variant=${productSingleVariant.id}`
      );

      const productSingleWarehouse = document.querySelector('.product-single__availability-area-availability--warehouse');
      const productSingleStore = document.querySelector('.product-single__availability-area-availability--store');

      if (productSingleStore && productSingleWarehouse) {
        if (productSingleVariant.inventory_policy === 'continue') {
          productSingleWarehouse.innerHTML = productSingleWarehouse.dataset.available;
        } else {
          productSingleWarehouse.innerHTML = productSingleWarehouse.dataset.notAvailable;
        }

        if (productSingleVariant.inventory_management && productSingleVariant.inventory_quantity > 0) {
          productSingleStore.innerHTML = productSingleStore.dataset.available;
          productSingleWarehouse.closest('.product-single__availability-area').classList.add('product-single__availability-area--hidden');
        } else {
          productSingleStore.innerHTML = productSingleStore.dataset.notAvailable;
          productSingleWarehouse.closest('.product-single__availability-area').classList.remove('product-single__availability-area--hidden');
        }
      }

      const etaFormTrigger = document.querySelector('.product-single__form-eta-trigger');
      
      if (productSingleVariant.available == true) {
        productSubmit.disabled = false;
        productSubmit.innerHTML = productSubmit.dataset.addText;
        if (etaFormTrigger) {
          etaFormTrigger.classList.remove('product-single__form-eta-trigger--display');
        }
      } else {
        productSubmit.disabled = true;
        productSubmit.innerHTML = productSubmit.dataset.soldOutText;
        if (etaFormTrigger) {
          etaFormTrigger.classList.add('product-single__form-eta-trigger--display');
        }
      }

      const variantPrice = productSingleVariant.price;
      const variantCap = productSingleVariant.compare_at_price;

      if (variantPrice < variantCap) {
        productPrice.innerHTML =
        '<del>$' +
        (variantCap / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
        "</del> $" +
        (variantPrice / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        productPrice.innerHTML = "$" + (variantPrice / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }

      productFormId.value = productSingleVariant.id;

      // Update the eta form if it exists
      const etaFormIframe = document.querySelector('.product-single__form-eta-form iframe');
      if (etaFormIframe) {
        const srcUrl = new URL(etaFormIframe.src);
        srcUrl.searchParams.set('productVariant', productSingleVariant.title);
        
        etaFormIframe.src = srcUrl.toString();
      }
    } else {
        // Variant doesn't exist
        productSubmit.disabled = true;
        productSubmit.innerHTML = productSubmit.dataset.soldOutText;
    }
  },

  klaviyoAddedToCart: (formData) => {
    var _learnq = window._learnq || [];
    fetch(`${window.location.origin}/cart.js`)
    .then(res => res.clone().json().then(data => {
      const addedItemId = formData.items[0].id;
      const addedItem = data.items.find(i => i.id == addedItemId);

      if (!addedItem) {
        return;
      }

      _learnq.push(['track', 'Added to Cart', addedItem]);
    }))
  },

  productAddToCart: (varaintId, quantity, productSubmit, properties) => {
    productSubmit.classList.add('button--loading');
    productSubmit.disabled = true;
	productSubmit.innerHTML = '&nbsp;';

    const cartContents = document.querySelector('[cart-drawer-contents]');
    gsap.to(cartContents, { duration: 0.25, opacity: 0 });

	let formData = {
      items: [
        {
          id: varaintId,
          quantity: quantity,
        },
      ],
      sections: "cart-drawer"
	};

	if (properties) {
      formData.items[0].properties = {};

      properties.forEach(property => {
        const name = property.name.match(/\[(.*?)\]/)[1];
        formData.items[0].properties[name.charAt(0).toUpperCase() + name.slice(1)] = property.value;
      });
	}

	fetch("/cart/add.js", {
    	method: "POST",
    	headers: {
          "Content-Type": "application/json",
    	},
    	body: JSON.stringify(formData),
	})
	.then((response) => {
      return response.json();
	})
	.then(data => {
      SC.klaviyoAddedToCart(formData);
      if (data.status == 422) {
        // Too many
        productSubmit.classList.remove('button--loading');
        productSubmit.textContent = productSubmit.dataset.cartLimitText;

        gsap.to(cartContents, { duration: 0.25, opacity: 1 });
      } else {
        // Added to cart
        SC.openCart();

        productSubmit.classList.remove('button--loading');
        productSubmit.disabled = false;
        productSubmit.textContent = productSubmit.dataset.addText;

        const headerCartItems = document.querySelectorAll("[header-cart-item-count]");
        headerCartItems.forEach(function(headerCartItem) {
          headerCartItem.setAttribute('header-cart-item-count', data.items.length);
          headerCartItem.textContent = data.items.length;
        });
        
        const updatedCart = new DOMParser().parseFromString(data.sections['cart-drawer'], 'text/html');
        cartContents.innerHTML = updatedCart.querySelector('[cart-drawer-contents]').innerHTML;

        gsap.to(cartContents, { duration: 0.25, opacity: 1 });
  
        SC.cart();
      }
    })
    .catch((error) => {
      console.error("Error:", error);
    });
  },

  productSingleAccordions: () => {
    const productSingleAccordions = document.querySelectorAll('[product-single-accordion-btn]');

    if (productSingleAccordions.length) {
      for (let productSingleAccordion of productSingleAccordions) {
        productSingleAccordion.addEventListener('click', () => {
          const expanded = productSingleAccordion.getAttribute('aria-expanded') === 'true';

          productSingleAccordion.setAttribute('aria-expanded', !expanded);
          productSingleAccordion.nextElementSibling.setAttribute('aria-expanded', !expanded);

          if (!expanded) {
            gsap.to(productSingleAccordion.nextElementSibling, { duration: 0.25, height: 'auto', autoAlpha: 1 });
          } else {
            gsap.to(productSingleAccordion.nextElementSibling, { duration: 0.25, height: 0, autoAlpha: 0 });
          }
        });
      }
    }
  },

  cart: () => {
    const cartCheckoutBtn = document.querySelector('[cart-drawer-checkout-btn]');

    if (cartCheckoutBtn) {
      cartCheckoutBtn.addEventListener('mouseover', () => {
        a.cartDrawer.classList.add('cart-drawer--checking-out');
      });

      cartCheckoutBtn.addEventListener('mouseout', () => {
        a.cartDrawer.classList.remove('cart-drawer--checking-out');
      });
    }
    
    const cartItems = document.querySelectorAll('[cart-form-item]');

	if (cartItems.length) {
      cartItems.forEach((cartItem, i) => {
        // Links
        const links = cartItem.querySelectorAll('a');

        for (let link of links) {
          link.addEventListener('click', () => {
            SC.closeCart();
          });
        }
        
        const index = i + 1;
        // Remove
        const itemRemove = cartItem.querySelector('[cart-form-item-remove]');

        itemRemove.addEventListener('click', () => {
          const formData = {
            'line': index,
            'quantity': 0,
            sections: "cart-drawer"
          }

          SC.updateCart(formData);
        });
  
        // Quantity
        const quantityField = cartItem.querySelector('[cart-drawer-item-qty-amount]');
        const quantityAddBtn = cartItem.querySelector('[cart-drawer-item-qty-plus]');
        const quantityMinusBtn = cartItem.querySelector('[cart-drawer-item-qty-minus]');

        quantityAddBtn.addEventListener('click', () => {
          const quantity = parseInt(quantityField.textContent) + 1;
          ///quantityField.textContent = quantity;

          const formData = {
            'line': index,
            'quantity': quantity,
            sections: "cart-drawer"
          }

          SC.updateCart(formData)
        });
          
        quantityMinusBtn.addEventListener('click', () => {
          const quantity = parseInt(quantityField.textContent) - 1;
          //quantityField.textContent = quantity;
  
          const formData = {
            'line': index,
            'quantity': quantity,
            sections: "cart-drawer"
          }

          SC.updateCart(formData);
        });
      });
	}
  },

  updateCart: (formData) => {
	a.cartDrawer.classList.add('drawer-loader--loading');
    const cartContents = document.querySelector('[cart-drawer-contents]');
    gsap.to(cartContents, { duration: 0.25, opacity: 0 });

	fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
	})
	.then(response => {
      return response.json()
	})
	.then(data => {
      if (data.status == 422) {
        // Too many
        a.cartDrawer.classList.remove('drawer-loader--loading');
        gsap.to(cartContents, { duration: 0.25, opacity: 1 });
      } else {
        const headerCartItems = document.querySelectorAll("[header-cart-item-count]");

        headerCartItems.forEach(function(headerCartItem) {
          headerCartItem.setAttribute('header-cart-item-count', data.item_count);
          headerCartItem.textContent = data.item_count;
        });
  
        const updatedCart = new DOMParser().parseFromString(data.sections['cart-drawer'], 'text/html');
        cartContents.innerHTML = updatedCart.querySelector('[cart-drawer-contents]').innerHTML;
  
        gsap.to(cartContents, { duration: 0.25, opacity: 1 });
  
        SC.cart();
  
        a.cartDrawer.classList.remove('drawer-loader--loading');
      }
	});
  },

  collectionFilteringMobile: () => {
    const filterMobToggle = document.querySelector('[collection-sortings-mob-toggle]');

    if (filterMobToggle) {
      filterMobToggle.addEventListener('click', () => {
        const expanded = filterMobToggle.getAttribute('aria-expanded') === 'true';

        filterMobToggle.setAttribute('aria-expanded', !expanded);
        filterMobToggle.nextElementSibling.setAttribute('aria-expanded', !expanded);

        filterMobToggle.parentNode.classList.toggle('collection__filter-mob--open');

        if (expanded) {
          setTimeout(() => filterMobToggle.parentNode.style.zIndex = 33, 250);
          document.body.classList.remove('overflow-hidden');
        } else {
          filterMobToggle.parentNode.style.zIndex = 120;
          document.body.classList.add('overflow-hidden');
        }
      });

      const filterMobShow = document.querySelector('[collection-sortings-mob-show]');

      if (filterMobShow) {
        filterMobShow.addEventListener('click', () => {  
          filterMobToggle.setAttribute('aria-expanded', false);
          filterMobToggle.nextElementSibling.setAttribute('aria-expanded', false);
          filterMobToggle.parentNode.classList.remove('collection__filter-mob--open');
          setTimeout(() => filterMobToggle.parentNode.style.zIndex = 33, 250);
        });
      }
    }
  },

  collectionFiltering: () => {
    const filterOptions = document.querySelectorAll('[collection-sortings-filter-option]');

    if (filterOptions) {
      for (const filterOption of filterOptions) {
        filterOption.addEventListener('click', () => {
          if (filterOption.classList.contains('collection__filter-type-option-btn--active')) {
            scbFiltering.currentFilters[filterOption.dataset.filter].tags = scbFiltering.currentFilters[filterOption.dataset.filter].tags.filter((tag) => tag != filterOption.dataset.value);
            
            const allSameFilters = document.querySelectorAll(`[data-value='${filterOption.dataset.value}']`);
            for (let allSameFilter of allSameFilters) {
              allSameFilter.classList.remove('collection__filter-type-option-btn--active');
            }
          } else {
            scbFiltering.currentFilters[filterOption.dataset.filter].tags.push(filterOption.dataset.value);

            const allSameFilters = document.querySelectorAll(`[data-value='${filterOption.dataset.value}']`);
            for (let allSameFilter of allSameFilters) {
              allSameFilter.classList.add('collection__filter-type-option-btn--active');
            }
          }
          SC.collectionFilteringRequest();

          const parentType = filterOption.closest('[collection-sortings-filter-type]');
          const clearBtn = parentType.querySelector('[collection-sortings-filter-clear]');

          if (scbFiltering.currentFilters[filterOption.dataset.filter].tags.length > 0) {
            clearBtn.disabled = false;
          } else {
            clearBtn.disabled = true;
          }
        });
      }
    }

    const sortOptions = document.querySelectorAll('[collection-sortings-sort-option]');

    if (sortOptions) {
      for (const sortOption of sortOptions) {
        sortOption.addEventListener('click', () => {
          if (!sortOption.classList.contains('collection__filter-type-option-btn--active')) {
            for (const sortOptionn of sortOptions) {
              if (sortOption != sortOptionn) {
                sortOptionn.classList.remove('collection__filter-type-option-btn--active');
              }
            }
            
            scbFiltering.currentSort.value = sortOption.dataset.value;
            //sortOption.classList.add('collection__filter-type-option-btn--active');
            
            const allSameSorts = document.querySelectorAll(`[data-value='${sortOption.dataset.value}']`);
            for (let allSameSort of allSameSorts) {
              allSameSort.classList.add('collection__filter-type-option-btn--active');
            }
            SC.collectionFilteringRequest();
          }
        });
      }
    }

    const filterOptionsClear = document.querySelectorAll('[collection-sortings-filter-clear]');

    if (filterOptionsClear) {
      for (const filterOptionClear of filterOptionsClear) {
        filterOptionClear.addEventListener('click', () => {
          const parentType = filterOptionClear.closest('[collection-sortings-filter-type]');
          const filterBtns = parentType.querySelectorAll('[collection-sortings-filter-option]');

          for (let filterBtn of filterBtns) {
            filterBtn.classList.remove('collection__filter-type-option-btn--active');
          }
          
          scbFiltering.currentFilters[filterOptionClear.dataset.filter].tags = [];
          SC.collectionFilteringRequest();

          filterOptionClear.disabled = true;
        });
      }
    }

    const filterOptionsMore = document.querySelectorAll('[collection-sortings-filter-more]');

    if (filterOptionsMore) {
      for (const filterOptionMore of filterOptionsMore) {
        filterOptionMore.addEventListener('click', () => {
          const controls = filterOptionMore.getAttribute('aria-controls');
          const popup = document.querySelector(`#${controls}`);
          filterOptionMore.setAttribute('aria-expanded', true);
          popup.setAttribute('aria-expanded', true);

          gsap.to(popup, { duration: 0.25, height: 'auto', opacity: 1 });
          gsap.to(filterOptionMore, { duration: 0.25, height: 0, opacity: 0, onComplete: () => filterOptionMore.style.display = 'none' });
        });
      }
    }
  },

  collectionFilteringRequest: () => {
    let url = scbFiltering.filterUrl;
    let parameters = '';
    for (const [filter, value] of Object.entries(scbFiltering.currentFilters)) {
      if (value.tags?.length > 0) {
          for (const tag of value.tags) {
              parameters += `&${value.param}=${tag}`;
          }
      }
    }

	if (scbFiltering.currentSort.value) {
      parameters += `&${scbFiltering.currentSort.param}=${scbFiltering.currentSort.value}`;
	}

    if (parameters) {
      if (url.includes('?')) {
        url = url + parameters;
      } else {
        url = url + '?' + parameters;
      }
    }

    url = url.replace('?&', '?');

    window.location.href = url;
    
    return;

  //   const productContainer = document.querySelector('[collection-items]');
	// const filterCounter = document.querySelector('[collection-count]');
  //   const filters = document.querySelector('[collection-filters]');

	// const tl = gsap.timeline();
	// tl.to(productContainer, { opacity: 0 });

  //   const abortController = new AbortController();

	// fetch(url, { signal: abortController.signal })
	// .then(response => {
  //     return response.text()
	// }).then(data => {
  //     const parser = new DOMParser();
  //     data = parser.parseFromString(data, 'text/html');

  //     window.scroll({ top: 0, left: 0, behavior: 'smooth' });

  //     const newProducts = data.querySelector('[collection-items]');
  //     const newFilterCount = data.querySelector('[collection-count]');
  //     const newFilters = data.querySelector('[collection-filters]');
      
  //     productContainer.innerHTML = newProducts.innerHTML;
  //     filterCounter.innerHTML = newFilterCount.innerHTML;
  //     filters.innerHTML = newFilters.innerHTML;

  //     SC.collectionFiltering();
  //     SC.collectionInfiniteLoading();

  //     tl.to(productContainer, { opacity: 1 });

  //     const dataa = {
  //       ...history.state,
  //       url,
  //       random: Math.random(),
  //       source: 'swup',
  //     };

  //     history.pushState(dataa, document.title, url);
      
	// })
  },

  collectionInfiniteLoading: () => {
    const collectionItems = document.querySelector('[collection-items]');

    if (!collectionItems) return;

    let infiniteProductsLoading = false;

    ScrollTrigger.create({
      trigger: collectionItems,
      start: 'bottom bottom+=50px',
      onEnter: async (self) => {
        if (infiniteProductsLoading) return;
        infiniteProductsLoading = true;

        try {
          await SC.loadInfiniteProducts(collectionItems);
          self.refresh();
          ScrollTrigger.refresh();
        } finally {
          infiniteProductsLoading = false;
          collectionItems.classList.remove('collection__grid--loading');
        }
      },
    });
  },

  loadInfiniteProducts: async (collectionItems) => {
    const paginationNext = document.querySelector('.collection__pagination-btn--next');

    if (!paginationNext) return;

    collectionItems.classList.add('collection__grid--loading');

    const response = await fetch(paginationNext.href);
    const html = await response.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    const newProducts = doc.querySelector('[collection-items]');

    const newPagination = doc.querySelector('.collection__pagination-btn--next');

    if (!newProducts) return;

    collectionItems.insertAdjacentHTML('beforeend', newProducts.innerHTML);

    const oldPaginationWrapper = paginationNext.closest('.collection__pagination');

    oldPaginationWrapper?.remove();

    if (newPagination) {
      collectionItems.insertAdjacentHTML(
        'afterend',
        `<div class="collection__pagination">${newPagination.outerHTML}</div>`
      );
    }
  },

  footer: () => {
    const target  = document.querySelector(".footer__statement");

    ScrollTrigger.create({
      trigger: ".footer__top",
      start:  "bottom bottom",
      onEnter: () => target.classList.add("footer__statement--active"),
      onLeaveBack: () => target.classList.remove("footer__statement--active")
    });
    
  },

  contentVisibiity: () => {
    const targets  = document.querySelectorAll(".custom-visibility");

    if (targets) {
      targets.forEach((t) => {
        ScrollTrigger.create({
          trigger: t,
          start: "top bottom",
          end: "bottom top",
          onEnter: () => t.classList.add("custom-visibility--visible"),
          onLeaveBack: () => t.classList.remove("custom-visibility--visible")
        });
      })
    }
    
  },

  newsletterPopup: () => {
    const newsletterPopupTriggers = document.querySelectorAll('[trigger-newsletter-popup]');

    if (newsletterPopupTriggers) {
      for (let newsletterPopupTrigger of newsletterPopupTriggers) {
        newsletterPopupTrigger.addEventListener('click', e => {
          e.preventDefault();
          a.newsletterPopup.classList.add('newsletter-popup--active');
          document.body.classList.add('overflow-hidden');
        });
      }
    }

    a.newsletterPopupCloseBtn.addEventListener('click', e => {
      a.newsletterPopup.classList.remove('newsletter-popup--active');
      document.body.classList.remove('overflow-hidden');
    });
    
    const newsletterPopupForm = document.querySelector('.newsletter-popup__form-form');

    if (newsletterPopupForm) {
      newsletterPopupForm.addEventListener('submit', e => {
        e.preventDefault();

        const button = newsletterPopupForm.querySelector('.newsletter-popup__form-form-btn');
        button.disabled = true;

        fetch(e.target.action, {
          method: 'POST',
          body: new FormData(e.target),
        }).then(response => {
          if (response.ok) {
            return response.text();
          }
        }).then(data => {
          const parser = new DOMParser();
          data = parser.parseFromString(data, 'text/html');

          const successCheck = data.querySelector('.newsletter-popup__form-form-success');

          if (successCheck) {
            e.target.insertAdjacentHTML('afterbegin', successCheck.outerHTML);
            e.target.reset();
          }

          button.disabled = false;
        }).catch(error => {
          console.warn(error);
        });
      });
    }
  },

  account: () => {
    const accountAccordionBtns = document.querySelectorAll('[account-accordion-trigger]');

    if (accountAccordionBtns) {
      for (let accountAccordionBtn of accountAccordionBtns) {
        accountAccordionBtn.addEventListener('click', e => {
          const expanded = accountAccordionBtn.getAttribute('aria-expanded') === 'true';
          const target = document.querySelector(`#${accountAccordionBtn.getAttribute('aria-controls')}`);

          accountAccordionBtn.setAttribute('aria-expanded', !expanded);
          target.setAttribute('aria-expanded', !expanded);

          if (!expanded) {
            gsap.to(target, { duration: 0.25, height: 'auto', autoAlpha: 1 });
          } else {
            gsap.to(target, { duration: 0.25, height: 0, autoAlpha: 0 });
          }
        });
      }
    }

    const accountAccordionCloseBtns = document.querySelectorAll('[account-accordion-close]');

    if (accountAccordionCloseBtns) {
      for (let accountAccordionCloseBtn of accountAccordionCloseBtns) {
        accountAccordionCloseBtn.addEventListener('click', e => {
          const parent = accountAccordionCloseBtn.closest('[aria-expanded=true]');

          const target = document.querySelector(`[aria-controls="${parent.id}"]`);
          target.click();
        });
      }
    }
    
  },

  paintProgram: () => {

    const paintProgramSpreadImages = document.querySelectorAll('.paint-program__block--spread .paint-program__images-figure-wrap');

    if (paintProgramSpreadImages) {
      for (let [i, paintProgramSpreadImage] of paintProgramSpreadImages.entries()) {
        const isEven = i % 2 == 0;

        const parent = paintProgramSpreadImages[0].parentElement;
        
        let tl = gsap.timeline({
          scrollTrigger: {
            trigger: parent,
            start: "top bottom",
            end: "bottom top",
            scrub: 0.5,
          }
        });

        const x = () => {
          const imageLeft = paintProgramSpreadImage.offsetLeft;
          const imageWidth = paintProgramSpreadImage.offsetWidth;
          
          return (parent.offsetWidth / 2) - (imageWidth / 2) - imageLeft;
        }

        const y = () => {
          const imageTop = paintProgramSpreadImage.offsetTop;
          const imageHeight = paintProgramSpreadImage.offsetHeight;
          
          return (parent.offsetHeight / 2) - (imageHeight / 2) - imageTop;
        }

        tl.to(paintProgramSpreadImage, { x: 0, y: 0 });
        tl.to(paintProgramSpreadImage, { x: x(), y: y() });
        tl.to(paintProgramSpreadImage, { x: 0, y: 0 });
      }
    }

    const paintProgramEnquireButton = document.querySelector('[paint-program-enquire-btn]');

    if (paintProgramEnquireButton) {
      paintProgramEnquireButton.addEventListener('click', e => {
        const expanded = paintProgramEnquireButton.getAttribute('aria-expanded') === 'true';

        paintProgramEnquireButton.setAttribute('aria-expanded', !expanded);
        const menuItemTarget = document.querySelector(`#${paintProgramEnquireButton.getAttribute('aria-controls')}`);
        menuItemTarget.setAttribute('aria-expanded', !expanded);

        if (!expanded) {
          gsap.to(menuItemTarget, { duration: 0.25, height: 'auto', autoAlpha: 1 });
        } else {
          gsap.to(menuItemTarget, { duration: 0.25, height: 0, autoAlpha: 0 });
        }
      });
    }
    
  },

  productEtaForm: () => {
    const etaFormTrigger = document.querySelector('.product-single__form-eta-trigger');
    const etaFormForm = document.querySelector('.product-single__form-eta-form--fresh');
    const etaFormClose = document.querySelector('.product-single__form-eta-form-close-button');

    const etaFormFormDuped = document.querySelector('.product-single__form-eta-form--duped');

    if (etaFormFormDuped) {
      etaFormFormDuped.remove();
    }
    
    if (etaFormForm) {
      etaFormForm.classList.remove('product-single__form-eta-form--fresh');
      etaFormForm.classList.add('product-single__form-eta-form--duped');
      document.body.appendChild(etaFormForm);
    }

    if (etaFormTrigger) {
      etaFormTrigger.addEventListener('click', () => {        
        etaFormForm.classList.add('product-single__form-eta-form--active');
        document.body.classList.add('overflow-hidden');
      });

      etaFormForm.addEventListener('click', () => {
        etaFormForm.classList.remove('product-single__form-eta-form--active');
        document.body.classList.remove('overflow-hidden');
      });

      etaFormClose.addEventListener('click', () => {
        etaFormForm.classList.remove('product-single__form-eta-form--active');
        document.body.classList.remove('overflow-hidden');
      });
    }
  }

};

(function() {
  SC.init();
})();